export function renderPopularSearches(container, results) {
	if (!container) return;
	container.innerHTML = '';

	results.request.forEach((search) => {
		const searchItem = document.createElement('div');
		searchItem.className = 'search-result-aside__item';
		searchItem.innerHTML = `
			<a href="${search.href}" class="search-result-aside__link search-result-aside__link--popular">${search.value}</a>
		`;
		container.appendChild(searchItem);
	});
}
